/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./toolbar-item-open-element.component";
import * as i2 from "../../../../../../../core/message/message-growl.service";
import * as i3 from "../../../../../services/double-click.service";
var styles_ToolbarItemOpenElement = [];
var RenderType_ToolbarItemOpenElement = i0.ɵcrt({ encapsulation: 2, styles: styles_ToolbarItemOpenElement, data: {} });
export { RenderType_ToolbarItemOpenElement as RenderType_ToolbarItemOpenElement };
export function View_ToolbarItemOpenElement_0(_l) { return i0.ɵvid(2, [], null, null); }
export function View_ToolbarItemOpenElement_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "toolbar-item-open-element", [], null, null, null, View_ToolbarItemOpenElement_0, RenderType_ToolbarItemOpenElement)), i0.ɵdid(1, 245760, null, 0, i1.ToolbarItemOpenElement, [i2.MessageGrowlService, i3.DoubleClickService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ToolbarItemOpenElementNgFactory = i0.ɵccf("toolbar-item-open-element", i1.ToolbarItemOpenElement, View_ToolbarItemOpenElement_Host_0, { params: "params" }, {}, []);
export { ToolbarItemOpenElementNgFactory as ToolbarItemOpenElementNgFactory };
